import type { SVGProps } from 'react';

import tw, { theme } from 'twin.macro';
import { Box } from '@chakra-ui/react';
import * as R from 'ramda';

const Polygon = ({ bg, id, ...props }: SVGProps<SVGSVGElement> & { bg: string, id: string }) => {
  return (
    <svg {...props} viewBox="0 0 56 62" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.25 2.60844L50.9628 13.9896C52.9739 15.1508 54.2128 17.2966 54.2128 19.6188V42.3812C54.2128 44.7034 52.9739 46.8493 50.9628 48.0104L31.25 59.3916C29.2389 60.5527 26.7611 60.5527 24.75 59.3916L5.03719 48.0104C3.02608 46.8493 1.78719 44.7034 1.78719 42.3812V19.6188C1.78719 17.2966 3.02608 15.1508 5.03719 13.9896L24.75 2.60844C26.7611 1.44733 29.2389 1.44733 31.25 2.60844Z"
        fill={bg}
        stroke={`url(#polygon-512b207c4d485a09766859ca7dd945cd-${id})`}
        strokeWidth="3"
      />
      <defs>
        <linearGradient
          id={`polygon-512b207c4d485a09766859ca7dd945cd-${id}`}
          x1="-4"
          y1="30.9999"
          x2="60"
          y2="30.9999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export interface LevelIconProps {
  level: number
  size?: number
  colorScheme?: string
}

const getPolygonColor = R.cond([
  [R.equals('legendary'), R.always(theme`textColor.legendary.500`)],
  [R.equals('magic'), R.always(theme`textColor.magic.500`)],
  [R.equals('prime'), R.always(theme`textColor.prime.500`)],
  [R.T, R.always(theme`textColor.brand.500`)]
])

export default function LevelIcon({ level, size = 16, colorScheme = 'default' }: LevelIconProps) {
  const textColor = getPolygonColor(colorScheme)
  return (
    <Box w={size} h={size} tw="flex flex-row items-center justify-center relative">
      <Polygon css={[tw`absolute z-0`, `color: ${textColor};`]} bg="#002321" id={colorScheme} />
      <code tw="font-secondary font-semibold text-xl text-white z-10 select-none">{level}</code>
    </Box>
  );
}
